<template>
  <!-- <div class="not-found">
		<p>{{ message }}</p>
	</div> -->

  <div class="no-results">
    <div class="no-results-content">
      <span class="material-symbols-outlined">search_off</span>
      <h3>{{ $t('Custom.noMatchingRecordFound')}}</h3>
      <p> {{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFoundContent",
  props: {
    message: {
      type: String,
      default: '',
    },
  },
  created() {
    if (!this.message) {
      this.message = this.$t('Custom.notFoundContent');
    }
  }
};
</script>

<style scoped>
.not-found {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px; /* Adjust as necessary */
  text-align: center;
  color: #888; /* Adjust text color as necessary */
}

.no-results {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
  text-align: center;
  color: #5f6368;
}

.no-results-content {
  max-width: 300px;
}

.no-results .material-symbols-outlined {
  font-size: 48px;
  margin-bottom: 16px;
  color: #dadce0;
}

.no-results h3 {
  margin: 8px 0;
  color: #202124;
}

.no-results p {
  margin: 0;
  font-size: 14px;
}
</style>
